import script from "./AdminLegalDocsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdminLegalDocsPage.vue?vue&type=script&setup=true&lang=ts"

import "./AdminLegalDocsPage.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__